<template>
  <div>
    <div class="toolbar">
      <el-select v-if="!readonly" v-model="supplierId" clearable filterable placeholder="供应商" style="width:200px" @change="load">
        <el-option v-for="s in suppliers" :key="s.id" :label="s.name" :value="s.id" />
      </el-select>
      <el-select v-model="status" clearable placeholder="审核状态" style="width:120px" @change="load">
        <el-option label="未审核" value="DRAFT" />
        <el-option label="已审核" value="CONFIRMED" />
      </el-select>
      <el-button type="primary" icon="el-icon-search" @click="load">查询</el-button>
      <el-button v-if="!readonly" type="primary" icon="el-icon-plus" @click="openEdit()">新增</el-button>
      <el-button v-if="!readonly" type="primary" icon="el-icon-upload2" @click="openImport">导入</el-button>
    </div>
    <el-table :data="pageList" border v-loading="loading">
      <el-table-column prop="supplierName" label="供应商" min-width="140" />
      <el-table-column label="开始日期" width="120">
        <template slot-scope="{ row }">{{ fmtDate(row.startDate) }}</template>
      </el-table-column>
      <el-table-column label="结束日期" width="120">
        <template slot-scope="{ row }">{{ fmtDate(row.endDate) }}</template>
      </el-table-column>
      <el-table-column prop="remark" label="备注" min-width="140" show-overflow-tooltip />
      <el-table-column prop="status" label="审核状态" width="100">
        <template slot-scope="{ row }">
          <el-tag size="mini" :type="statusType(contractStatusMap, row.status)">
            {{ statusLabel(contractStatusMap, row.status) }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="confirmedAt" label="审核时间" width="170" />
      <el-table-column label="操作" width="230" fixed="right">
        <template slot-scope="{ row }">
          <el-button type="text" @click="openDetail(row)">明细</el-button>
          <template v-if="!readonly">
            <el-button
              type="text"
              :disabled="row.status!=='DRAFT'"
              @click="openEdit(row)"
            >编辑</el-button>
            <el-button
              type="text"
              :disabled="row.status!=='DRAFT'"
              @click="onConfirm(row)"
            >审核</el-button>
            <el-button
              type="text"
              :disabled="row.status!=='CONFIRMED'"
              @click="onUnconfirm(row)"
            >反审核</el-button>
            <el-button
              type="text"
              class="op-danger"
              :disabled="row.status!=='DRAFT'"
              @click="onDelete(row)"
            >删除</el-button>
          </template>
        </template>
      </el-table-column>
    </el-table>
    <list-pagination
      :total="listTotal"
      :page="page"
      :page-size="pageSize"
      @current-change="onPageChange"
      @size-change="onPageSizeChange"
    />

    <el-dialog v-if="!readonly" :title="form.id?'编辑价格表':'新增价格表'" :visible.sync="visible" width="960px">
      <el-form :model="form" label-width="90px">
        <el-row :gutter="12">
          <el-col :span="24">
            <el-form-item label="供应商" required>
              <el-select v-model="form.supplierId" filterable style="width:100%" @change="onSupplierChange">
                <el-option v-for="s in suppliers" :key="s.id" :label="s.name" :value="s.id" />
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="12">
          <el-col :span="12">
            <el-form-item label="开始日期" required>
              <el-date-picker
                v-model="form.startDate"
                type="date"
                value-format="yyyy-MM-dd"
                placeholder="开始日期"
                style="width:100%"
              />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="结束日期" required>
              <el-date-picker
                v-model="form.endDate"
                type="date"
                value-format="yyyy-MM-dd"
                placeholder="结束日期"
                style="width:100%"
              />
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item label="备注">
          <el-input v-model="form.remark" />
        </el-form-item>
        <el-form-item label="材料明细" required>
          <el-button size="mini" type="primary" plain @click="openPickMaterial">选择材料</el-button>
          <el-button size="mini" type="primary" plain style="margin-left:8px" @click="openAddMaterial">新增材料</el-button>
          <el-table :data="form.lines" border size="small" style="margin-top:8px">
            <el-table-column type="index" label="序号" width="55" align="center" />
            <el-table-column label="材料" min-width="160" prop="materialName" show-overflow-tooltip />
            <el-table-column label="规格" width="100" show-overflow-tooltip>
              <template slot-scope="{ row }">{{ row.spec || '-' }}</template>
            </el-table-column>
            <el-table-column label="单位" width="70" align="center">
              <template slot-scope="{ row }">{{ row.unit || '-' }}</template>
            </el-table-column>
            <el-table-column label="销售单价" width="130">
              <template slot-scope="{ row }">
                <el-input-number v-model="row.price" :min="0" :precision="2" :step="1" size="mini" controls-position="right" style="width:110px" />
              </template>
            </el-table-column>
            <el-table-column label="采购单价" width="130">
              <template slot-scope="{ row }">
                <el-input-number v-model="row.costPrice" :min="0" :precision="2" :step="1" size="mini" controls-position="right" style="width:110px" />
              </template>
            </el-table-column>
            <el-table-column label="备注" min-width="120">
              <template slot-scope="{ row }">
                <el-input v-model="row.remark" size="mini" placeholder="选填" />
              </template>
            </el-table-column>
            <el-table-column width="60" fixed="right">
              <template slot-scope="{ $index }">
                <el-button type="text" style="color:#ef4444" @click="form.lines.splice($index,1)">删</el-button>
              </template>
            </el-table-column>
          </el-table>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="visible=false">取消</el-button>
        <el-button type="primary" :loading="saving" @click="save">保存</el-button>
      </div>
    </el-dialog>

    <el-dialog
      v-if="!readonly"
      title="选择材料"
      :visible.sync="pickVisible"
      width="760px"
      append-to-body
      @closed="onPickClosed"
    >
      <div class="pick-toolbar">
        <el-input
          v-model="pickKeyword"
          clearable
          placeholder="名称 / 规格 / 分类"
          style="width:240px"
          @keyup.enter.native="loadPickList"
        />
        <el-button type="primary" icon="el-icon-search" @click="loadPickList">查询</el-button>
      </div>
      <el-table
        ref="pickTable"
        :data="pickPageList"
        border
        size="small"
        row-key="id"
        v-loading="pickLoading"
        max-height="420"
        @selection-change="onPickSelectionChange"
      >
        <el-table-column type="selection" width="45" :selectable="pickSelectable" reserve-selection />
        <el-table-column prop="name" label="材料名称" min-width="140" show-overflow-tooltip />
        <el-table-column label="分类" width="110" show-overflow-tooltip>
          <template slot-scope="{ row }">{{ row.categoryName || row.category || '-' }}</template>
        </el-table-column>
        <el-table-column prop="spec" label="规格" width="110" show-overflow-tooltip />
        <el-table-column prop="unit" label="单位" width="70" align="center" />
        <el-table-column label="采购单价" width="100" align="right">
          <template slot-scope="{ row }">{{ formatMoney(row.costPrice) }}</template>
        </el-table-column>
        <el-table-column label="销售单价" width="100" align="right">
          <template slot-scope="{ row }">{{ formatMoney(row.salePrice) }}</template>
        </el-table-column>
      </el-table>
      <list-pagination
        :total="pickTotal"
        :page="pickPage"
        :page-size="pickPageSize"
        @current-change="onPickPageChange"
        @size-change="onPickPageSizeChange"
      />
      <div slot="footer">
        <el-button @click="pickVisible=false">取消</el-button>
        <el-button type="primary" @click="confirmPickMaterials">确定</el-button>
      </div>
    </el-dialog>

    <el-dialog
      v-if="!readonly"
      title="新增材料"
      :visible.sync="matVisible"
      width="520px"
      append-to-body
    >
      <el-form :model="matForm" label-width="90px">
        <el-form-item label="名称" required><el-input v-model="matForm.name" /></el-form-item>
        <el-form-item label="分类" required>
          <el-cascader
            v-model="matForm.categoryId"
            :options="categoryTree"
            :props="leafCascaderProps"
            clearable
            filterable
            placeholder="请选择末级分类"
            style="width:100%"
          />
        </el-form-item>
        <el-form-item label="规格"><el-input v-model="matForm.spec" /></el-form-item>
        <el-form-item label="单位" required>
          <unit-select-with-add v-model="matForm.unit" />
        </el-form-item>
        <el-form-item label="采购单价">
          <el-input-number
            v-model="matForm.costPrice"
            :min="0"
            :precision="2"
            :step="1"
            controls-position="right"
            style="width:100%"
            placeholder="不填默认为 0"
          />
        </el-form-item>
        <el-form-item label="销售单价">
          <el-input-number
            v-model="matForm.salePrice"
            :min="0"
            :precision="2"
            :step="1"
            controls-position="right"
            style="width:100%"
            placeholder="不填默认为 0"
          />
        </el-form-item>
        <el-form-item label="状态"><el-switch v-model="matForm.enabled" :active-value="1" :inactive-value="0" /></el-form-item>
        <el-form-item label="备注"><el-input v-model="matForm.remark" /></el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="matVisible=false">取消</el-button>
        <el-button type="primary" :loading="matSaving" @click="saveMaterialQuick">保存</el-button>
      </div>
    </el-dialog>

    <el-drawer title="价格表明细" :visible.sync="detailVisible" size="640px">
      <div style="padding:0 16px 16px">
        <el-table :data="detailLines" border size="small">
          <el-table-column type="index" label="序号" width="55" align="center" />
          <el-table-column prop="materialName" label="材料" min-width="120" />
          <el-table-column prop="spec" label="规格" width="100" show-overflow-tooltip />
          <el-table-column prop="unit" label="单位" width="70" />
          <el-table-column prop="price" label="销售单价" width="100" />
          <el-table-column prop="costPrice" label="采购单价" width="100" />
          <el-table-column prop="remark" label="备注" min-width="100" show-overflow-tooltip />
        </el-table>
      </div>
    </el-drawer>

    <el-dialog v-if="!readonly" title="导入材料价格" :visible.sync="importVisible" width="560px" @close="resetImport">
      <div class="import-steps">
        <p>1. 先下载模板，按表头填写后上传。</p>
        <el-button type="text" icon="el-icon-download" @click="downloadTemplate">下载导入模板</el-button>
        <div class="import-tips">
          <div class="import-tips-title">说明</div>
          <ol>
            <li>请从第2行开始填写，勿修改表头；带红星列为必填。</li>
            <li>供应商、材料请从下拉列表选择。</li>
            <li>相同供应商+开始/结束日期的行会合并为一张未审核价格表。</li>
            <li>全部校验通过后才会导入。</li>
          </ol>
        </div>
        <p style="margin-top:12px">2. 上传填写好的 Excel（.xlsx / .xls）。</p>
        <el-upload
          ref="importUpload"
          action=""
          :auto-upload="false"
          :limit="1"
          accept=".xlsx,.xls"
          :on-change="onImportFileChange"
          :on-remove="onImportFileRemove"
          :file-list="importFileList"
        >
          <el-button size="small" type="primary">选择文件</el-button>
        </el-upload>
      </div>
      <div v-if="importErrors.length" class="import-errors">
        <div class="import-errors-title">
          校验未通过：总计 {{ importTotal }} 条，成功导入 0 条。问题如下：
        </div>
        <el-table :data="importErrors" border size="mini" max-height="280">
          <el-table-column prop="message" label="问题" min-width="220" />
          <el-table-column label="行号" min-width="160">
            <template slot-scope="{ row }">{{ row.rowText || (row.rows || []).join('，') }}</template>
          </el-table-column>
        </el-table>
      </div>
      <div slot="footer">
        <el-button @click="importVisible=false">关闭</el-button>
        <el-button type="primary" :loading="importing" :disabled="!importFile" @click="doImport">开始导入</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  listContracts, getContract, saveContract, deleteContract,
  confirmContract, unconfirmContract, listSuppliers, listMaterials,
  saveMaterial, treeMaterialCategories,
  downloadContractImportTemplate, importContracts
} from '../../api/supply'
import { fetchNav } from '../../api/auth'
import { hasMenuAccess } from '../../utils/nav'
import { contractStatusMap, statusLabel, statusType } from '../../utils/status'
import ListPagination from '../../components/ListPagination.vue'
import UnitSelectWithAdd from '../../components/UnitSelectWithAdd.vue'
import listPaging from '../../mixins/listPaging'

export default {
  name: 'Contract',
  components: { ListPagination, UnitSelectWithAdd },
  mixins: [listPaging],
  props: { readonly: { type: Boolean, default: false } },
  data() {
    return {
      contractStatusMap,
      supplierId: null, status: '', suppliers: [], list: [],
      loading: false, saving: false,
      visible: false, form: { lines: [] },
      detailVisible: false, detailLines: [],
      matVisible: false,
      matSaving: false,
      matForm: {},
      categoryTree: [],
      navMenus: null,
      leafCascaderProps: {
        value: 'id',
        label: 'name',
        children: 'children',
        emitPath: false,
        checkStrictly: false
      },
      pickVisible: false,
      pickKeyword: '',
      pickList: [],
      pickLoading: false,
      pickPage: 1,
      pickPageSize: 15,
      pickSelection: [],
      importVisible: false,
      importing: false,
      importFile: null,
      importFileList: [],
      importErrors: [],
      importTotal: 0
    }
  },
  computed: {
    pickPageList() {
      const list = this.pickList || []
      const start = (this.pickPage - 1) * this.pickPageSize
      return list.slice(start, start + this.pickPageSize)
    },
    pickTotal() {
      return (this.pickList || []).length
    },
    selectedMaterialIds() {
      return new Set((this.form.lines || []).map(l => l.materialId).filter(Boolean))
    }
  },
  created() {
    if (!this.readonly) {
      this.loadSuppliers()
      this.loadMatMeta()
    }
    this.load()
  },
  methods: {
    statusLabel, statusType,
    fmtDate(v) {
      if (!v) return '-'
      const s = String(v)
      return s.length >= 10 ? s.slice(0, 10) : s
    },
    formatMoney(v) {
      if (v == null || v === '') return '0.00'
      const n = Number(v)
      return Number.isFinite(n) ? n.toFixed(2) : '0.00'
    },
    async loadMatMeta() {
      try {
        const catRes = await treeMaterialCategories()
        this.categoryTree = catRes.data || []
      } catch (e) {
        this.categoryTree = []
      }
    },
    async ensureNavMenus() {
      if (this.navMenus) return this.navMenus
      const res = await fetchNav()
      this.navMenus = res.data || []
      return this.navMenus
    },
    async canAddMaterial() {
      const menus = await this.ensureNavMenus()
      return hasMenuAccess(menus, { path: '/master/material', perms: 'biz:material:list' })
    },
    async openAddMaterial() {
      if (!(await this.canAddMaterial())) {
        return this.$message.warning('没有新增材料权限')
      }
      this.matForm = {
        id: null,
        name: '',
        categoryId: null,
        spec: '',
        unit: '',
        costPrice: 0,
        salePrice: 0,
        enabled: 1,
        remark: ''
      }
      this.matVisible = true
    },
    lineFromMaterial(m) {
      return {
        materialId: m.id,
        materialName: m.name || '',
        spec: m.spec || '',
        unit: m.unit || '',
        price: m.salePrice == null ? 0 : Number(m.salePrice),
        costPrice: m.costPrice == null ? 0 : Number(m.costPrice),
        remark: ''
      }
    },
    async saveMaterialQuick() {
      if (!this.matForm.name) {
        return this.$message.warning('请填写材料名称')
      }
      if (!this.matForm.categoryId) return this.$message.warning('请选择末级分类')
      if (!this.matForm.unit) return this.$message.warning('请选择单位')
      this.matSaving = true
      try {
        const res = await saveMaterial({
          ...this.matForm,
          costPrice: this.matForm.costPrice == null || this.matForm.costPrice === '' ? 0 : this.matForm.costPrice,
          salePrice: this.matForm.salePrice == null || this.matForm.salePrice === '' ? 0 : this.matForm.salePrice
        })
        const saved = res.data || {}
        this.$message.success('材料已新增')
        this.matVisible = false
        if (saved.id) {
          if (this.selectedMaterialIds.has(saved.id)) {
            return
          }
          this.form.lines.push(this.lineFromMaterial(saved))
        }
      } finally {
        this.matSaving = false
      }
    },
    async loadSuppliers() {
      const res = await listSuppliers({})
      this.suppliers = (res.data || []).filter(s => s.enabled !== 0)
    },
    async load() {
      this.loading = true
      try {
        const res = await listContracts({
          supplierId: this.supplierId || undefined,
          status: this.status || undefined
        })
        this.list = res.data || []
        this.page = 1
      } finally { this.loading = false }
    },
    onSupplierChange() {
      this.form.lines = []
    },
    async openPickMaterial() {
      this.pickKeyword = ''
      this.pickSelection = []
      this.pickPage = 1
      this.pickVisible = true
      await this.loadPickList()
    },
    async loadPickList() {
      this.pickLoading = true
      try {
        const res = await listMaterials({
          keyword: this.pickKeyword || undefined
        })
        this.pickList = (res.data || []).filter(m => m.enabled !== 0)
        this.pickPage = 1
        this.pickSelection = []
        this.$nextTick(() => {
          if (this.$refs.pickTable) this.$refs.pickTable.clearSelection()
        })
      } finally {
        this.pickLoading = false
      }
    },
    pickSelectable(row) {
      return !this.selectedMaterialIds.has(row.id)
    },
    onPickSelectionChange(rows) {
      this.pickSelection = rows || []
    },
    onPickPageChange(p) {
      this.pickPage = p
    },
    onPickPageSizeChange(s) {
      this.pickPageSize = s
      this.pickPage = 1
    },
    onPickClosed() {
      this.pickSelection = []
      this.pickList = []
    },
    confirmPickMaterials() {
      const selected = this.pickSelection || []
      if (!selected.length) {
        return this.$message.warning('请先勾选材料')
      }
      let added = 0
      selected.forEach(m => {
        if (!m || !m.id || this.selectedMaterialIds.has(m.id)) return
        this.form.lines.push(this.lineFromMaterial(m))
        added += 1
      })
      if (!added) {
        return this.$message.warning('所选材料已在明细中')
      }
      this.pickVisible = false
      this.$message.success(`已添加 ${added} 个材料`)
    },
    openImport() {
      this.resetImport()
      this.importVisible = true
    },
    resetImport() {
      this.importFile = null
      this.importFileList = []
      this.importErrors = []
      this.importTotal = 0
      this.importing = false
    },
    onImportFileChange(file, fileList) {
      this.importFileList = fileList.slice(-1)
      this.importFile = file.raw || null
      this.importErrors = []
      this.importTotal = 0
    },
    onImportFileRemove() {
      this.importFile = null
      this.importFileList = []
      this.importErrors = []
      this.importTotal = 0
    },
    async downloadTemplate() {
      try {
        const res = await downloadContractImportTemplate()
        const blob = new Blob([res.data], {
          type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
        })
        const url = URL.createObjectURL(blob)
        const a = document.createElement('a')
        a.href = url
        a.download = '材料价格导入模板.xlsx'
        document.body.appendChild(a)
        a.click()
        document.body.removeChild(a)
        URL.revokeObjectURL(url)
      } catch (e) {
        this.$message.error('模板下载失败')
      }
    },
    async doImport() {
      if (!this.importFile) return this.$message.warning('请先选择文件')
      this.importing = true
      this.importErrors = []
      try {
        const res = await importContracts(this.importFile)
        const data = res.data || {}
        const total = data.total == null ? 0 : Number(data.total)
        const imported = data.imported == null ? 0 : Number(data.imported)
        this.importTotal = total
        if (data.ok) {
          this.$message.success(`导入完成：总计 ${total} 条，成功导入 ${imported} 条`)
          this.importVisible = false
          this.load()
        } else {
          this.importErrors = data.errors || []
          this.$message.error(`校验未通过：总计 ${total} 条，成功导入 0 条`)
        }
      } catch (e) { /* interceptor */ }
      finally {
        this.importing = false
      }
    },
    async openEdit(row) {
      if (!row) {
        this.form = {
          id: null,
          supplierId: this.supplierId,
          contractNo: '',
          startDate: '',
          endDate: '',
          remark: '',
          lines: []
        }
        this.visible = true
        return
      }
      const res = await getContract(row.id)
      const d = res.data || {}
      const c = d.contract || d
      this.form = {
        id: c.id,
        supplierId: c.supplierId,
        contractNo: c.contractNo,
        startDate: this.fmtDate(c.startDate) === '-' ? '' : this.fmtDate(c.startDate),
        endDate: this.fmtDate(c.endDate) === '-' ? '' : this.fmtDate(c.endDate),
        remark: c.remark,
        lines: (d.lines || []).map(l => ({
          materialId: l.materialId,
          materialName: l.materialName || '',
          spec: l.spec || '',
          unit: l.unit || '',
          price: l.price == null ? undefined : Number(l.price),
          costPrice: l.costPrice == null ? undefined : Number(l.costPrice),
          remark: l.remark || ''
        }))
      }
      this.visible = true
    },
    async openDetail(row) {
      const res = await getContract(row.id)
      this.detailLines = (res.data && res.data.lines) || []
      this.detailVisible = true
    },
    async save() {
      if (!this.form.supplierId) {
        return this.$message.warning('请选择供应商')
      }
      if (!this.form.startDate || !this.form.endDate) {
        return this.$message.warning('请填写开始日期和结束日期')
      }
      if (this.form.endDate < this.form.startDate) {
        return this.$message.warning('结束日期不能早于开始日期')
      }
      if (!this.form.lines.length || this.form.lines.some(l => !l.materialId)) {
        return this.$message.warning('请选择材料明细')
      }
      this.form.lines.forEach(l => {
        if (l.price == null || l.price === '') l.price = 0
        if (l.costPrice == null || l.costPrice === '') l.costPrice = 0
      })
      this.saving = true
      try {
        await saveContract(this.form)
        this.$message.success('已保存')
        this.visible = false
        this.load()
      } catch (e) { /* interceptor shows message */ }
      finally { this.saving = false }
    },
    onConfirm(row) {
      this.$confirm('审核后可用于材料申请选价，是否审核？', '审核价格表', { type: 'warning' })
        .then(async () => { await confirmContract(row.id); this.$message.success('已审核'); this.load() })
        .catch(() => {})
    },
    onUnconfirm(row) {
      this.$confirm('反审核后不可用于领料选价，是否继续？', '反审核', { type: 'warning' })
        .then(async () => { await unconfirmContract(row.id); this.$message.success('已反审核'); this.load() })
        .catch(() => {})
    },
    onDelete(row) {
      this.$confirm('确认删除该价格表？', '提示', { type: 'warning' })
        .then(async () => { await deleteContract(row.id); this.$message.success('已删除'); this.load() })
        .catch(() => {})
    }
  }
}
</script>

<style scoped>
.toolbar { display:flex; gap:8px; margin-bottom:12px; flex-wrap:wrap; }
.pick-toolbar { display:flex; gap:8px; margin-bottom:12px; flex-wrap:wrap; }
.import-steps { line-height: 1.6; }
.import-tips {
  margin-top: 8px;
  padding: 10px 12px;
  background: #f8fafc;
  border-radius: 6px;
  color: #475569;
  font-size: 13px;
}
.import-tips-title { font-weight: 600; margin-bottom: 4px; color: #334155; }
.import-tips ol { margin: 0; padding-left: 18px; }
.import-errors { margin-top: 14px; }
.import-errors-title { margin-bottom: 8px; color: #b91c1c; font-size: 13px; }
</style>
